
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/transportbil/campervan",
      function () {
        return require("private-next-pages/tyres/transportbil/campervan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/transportbil/campervan"])
      });
    }
  